import { Entity, UniqueEntityId } from "@kernel/ddd";
import { cloneDeep } from "lodash";
import { StatsRecorderService } from "./StatsRecorderService";
import { RemoteParticipantList } from "domain/room";
import { StatsDto, StatsToDtoEntity } from "./dto";

export interface StatsRecorderProps {
  roomName: string;
  date: Date;
}

export class StatsRecorder
  extends Entity<StatsRecorderProps>
  implements StatsToDtoEntity
{
  private service: StatsRecorderService;

  private constructor(props: StatsRecorderProps, id?: UniqueEntityId) {
    super(props, id);
    this.service = new StatsRecorderService();
  }

  public get id(): UniqueEntityId {
    return this._id;
  }

  public get roomName(): string {
    return this.props.roomName;
  }

  public get date(): Date {
    return this.props.date;
  }

  public get timestamp(): number {
    return this.props.date.getTime();
  }

  public start(participants: RemoteParticipantList): void {
    this.service.start(participants);
  }

  public stop(): void {
    this.service.stop();
  }

  public getService(): StatsRecorderService {
    return this.service;
  }

  public clone(): StatsRecorder {
    const props = cloneDeep(this.props);
    return new StatsRecorder(props, new UniqueEntityId(this.id.toValue()));
  }

  public toString(): string {
    return `stats.${this.props.roomName}.${this.props.date.getTime()}`;
  }

  public toDto(): StatsDto {
    return {
      id: this.id.toString(),
      roomName: this.roomName,
      timestamp: this.date.getTime(),
      report: {}
    };
  }

  public static create(
    props: StatsRecorderProps,
    id?: UniqueEntityId
  ): StatsRecorder {
    return new StatsRecorder(props, id);
  }
}
